import React from "react";
import "../style/home.css";
import "../style/slider.css";
import Navbar_web from "../components/Navbar_web";
import Slider from "../components/Slider";
import CardCarousel from "../components/Card_carousel";
import CategoryWeb_card from "../components/CategoryWeb_card";
import Footer from "../components/Footer";
import img from "../images/banner/banner.jpg";

export default function Home() {
  return (
    <>
      <div className="home_container">
        <div className="nav_section">
          <Navbar_web />
        </div>
        <div className="slider_section">
          <Slider />
        </div>
        <div className="card_section">
          <div className="heading_name">
            <h2>Diamond Best Sellers</h2>
            <span>Dazzling diamond jewellery, now at delightful prices</span>
          </div>
          <CardCarousel />
        </div>
        <div className="category_section">
          <div className="heading_name">
            <h2>Shop By Category</h2>
            <span>
              Browse through your favorite categories. We've got them all!
            </span>
          </div>
          <CategoryWeb_card />
        </div>
        <div className="img_section">
          <img src={img} alt="" />
        </div>
        <div className="footer_section">
          <Footer/>
        </div>
      </div>
    </>
  );
}
